"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientPicker = exports.clientShapeExcludes = exports.getClientShape = exports.ClientTypes = void 0;
var react_1 = __importStar(require("react"));
var yup = __importStar(require("yup"));
var labels_1 = require("../labels");
var controls_1 = require("../controls");
var inputs_1 = require("../inputs");
var layout_1 = require("../layout");
var pickers_1 = require("../pickers");
var validation_1 = require("../validation");
var ClientTypes;
(function (ClientTypes) {
    ClientTypes["Business"] = "Business";
    ClientTypes["Individual"] = "Individual";
})(ClientTypes = exports.ClientTypes || (exports.ClientTypes = {}));
var getClientShape = function (getClientById) { return ({
    clientIdKnown: yup.boolean().required().label("Customer ID"),
    clientType: yup
        .mixed()
        .oneOf(Object.values(ClientTypes))
        .when("clientIdKnown", {
        is: function (clientIdKnown) { return clientIdKnown === false; },
        then: function (schema) { return schema.required(); },
    })
        .label("Question"),
    clientId: yup
        .string()
        .when("clientIdKnown", {
        is: function (clientIdKnown) { return clientIdKnown === true; },
        then: function (schema) {
            return schema.required().test(function (v) { return __awaiter(void 0, void 0, void 0, function () {
                var res, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!v) {
                                return [2, true];
                            }
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4, getClientById(v)];
                        case 2:
                            res = _b.sent();
                            return [2, res ? true : false];
                        case 3:
                            _a = _b.sent();
                            return [2, false];
                        case 4: return [2];
                    }
                });
            }); });
        },
    })
        .when(["clientIdKnown", "clientType", "clientABN", "clientEmail"], {
        is: function (clientIdKnown, clientType, clientABN, clientEmail) {
            if (clientIdKnown !== false)
                return false;
            return (clientType == ClientTypes.Business && clientABN) ||
                (clientType == ClientTypes.Individual && clientEmail)
                ? true
                : false;
        },
        then: function (schema) { return schema.required(); },
    })
        .label("Customer ID"),
    clientABN: yup
        .string()
        .when(["clientIdKnown", "clientType"], {
        is: function (clientIdKnown, clientType) {
            return clientIdKnown === false && clientType === ClientTypes.Business;
        },
        then: function (schema) { return schema.required(); },
    })
        .label("ABN"),
    clientEmail: yup
        .string()
        .when(["clientIdKnown", "clientType", "clientId"], {
        is: function (clientIdKnown, clientType, clientId) {
            return (clientIdKnown === false &&
                clientType === ClientTypes.Individual) ||
                clientId == "new";
        },
        then: function (schema) { return schema.required(); },
    })
        .label("Email"),
    clientName: yup
        .string()
        .label("Trading Name")
        .when("clientId", {
        is: function (clientId) { return clientId == "new"; },
        then: function (schema) { return schema.required(); },
    }),
    clientFirstName: yup
        .string()
        .label("First Name")
        .when("clientId", {
        is: function (clientId) { return clientId == "new"; },
        then: function (schema) { return schema.required(); },
    }),
    clientLastName: yup
        .string()
        .label("Last Name")
        .when("clientId", {
        is: function (clientId) { return clientId == "new"; },
        then: function (schema) { return schema.required(); },
    }),
    clientBusinessPhone: yup
        .string()
        .label("Main Phone")
        .when("clientId", {
        is: function (clientId) { return clientId == "new"; },
        then: function (schema) { return schema.required(); },
    }),
    clientMobile: yup.string().label("Mobile"),
    clientOtherPhone: yup.string().label("Other Phone"),
    clientPostalAddress: pickers_1.AddressSchema.when("clientId", {
        is: function (clientId) { return clientId == "new"; },
        then: function (schema) { return schema.required("Address is required"); },
    }).default(undefined),
    clientBusinessAddress: pickers_1.AddressSchema.default(undefined)
}); };
exports.getClientShape = getClientShape;
exports.clientShapeExcludes = [["clientEmail", "clientId"]];
var ClientPicker = function (_a) {
    var value = _a.value, onChange = _a.onChange, errors = _a.errors, readOnly = _a.readOnly, className = _a.className, props = __rest(_a, ["value", "onChange", "errors", "readOnly", "className"]);
    var _b = (0, react_1.useState)(""), registeredName = _b[0], setRegisteredName = _b[1];
    var _c = (0, react_1.useState)(null), clientDetails = _c[0], setClientDetails = _c[1];
    var _d = (0, react_1.useState)(null), clientReferences = _d[0], setClientReferences = _d[1];
    var setClientId = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
        var d, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    onChange({ clientId: clientId });
                    if (!(clientId && clientId != "new")) return [3, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, props.getClientById(clientId)];
                case 2:
                    d = _b.sent();
                    setClientDetails(d ? d : {});
                    if (d) {
                        onChange({
                            clientId: clientId,
                            clientType: d.abn
                                ? ClientTypes.Business
                                : ClientTypes.Individual,
                            clientABN: d.abn,
                            clientName: d.name,
                            clientEmail: d.email
                        }, validation_1.ValidationHint.NoValidation);
                    }
                    else {
                        onChange({
                            clientId: clientId,
                            clientType: undefined,
                            clientABN: undefined,
                            clientName: undefined,
                            clientEmail: undefined
                        }, validation_1.ValidationHint.NoValidation);
                    }
                    return [3, 4];
                case 3:
                    _a = _b.sent();
                    setClientDetails({});
                    onChange({
                        clientId: clientId,
                        clientType: undefined,
                        clientABN: undefined,
                        clientName: undefined,
                        clientEmail: undefined
                    }, validation_1.ValidationHint.NoValidation);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (value.clientId && value.clientId != "new") {
            props.getClientById(value.clientId).then(function (d) {
                setClientDetails(d ? d : {});
            }).catch(function () {
                setClientDetails({});
            });
        }
    }, []);
    (0, react_1.useEffect)(function () {
        onChange({
            clientEmail: value.clientType == ClientTypes.Business ? undefined : value.clientEmail,
            clientABN: value.clientType == ClientTypes.Individual ? undefined : value.clientABN,
        }, validation_1.ValidationHint.NoValidation);
    }, [value.clientType]);
    (0, react_1.useEffect)(function () {
        setClientReferences(null);
        var res;
        if (value.clientABN) {
            res = props.getClientsByAbn(value.clientABN);
        }
        else if (value.clientEmail) {
            res = props.getClientsByEmail(value.clientEmail);
        }
        else {
            res = Promise.resolve([]);
        }
        res.then(function (d) {
            setClientReferences(d);
            if (value.clientId != "new" && d.filter(function (r) { return r.clientId == value.clientId; }).length == 0) {
                onChange({ clientId: undefined }, validation_1.ValidationHint.NoValidation);
            }
        }).catch(function () {
            onChange({ clientId: undefined }, validation_1.ValidationHint.NoValidation);
            setClientReferences([]);
        });
    }, [value.clientABN, value.clientABN ? null : value.clientEmail]);
    return react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col col-12" },
                react_1.default.createElement(labels_1.Label, { id: "clientIdKnown", label: "Do you have a customer ID?", error: errors === null || errors === void 0 ? void 0 : errors.clientIdKnown, required: true },
                    react_1.default.createElement(controls_1.RadioList, { disabled: readOnly, id: "clientIdKnown", value: value.clientIdKnown, options: [
                            {
                                label: "I have a customer ID",
                                value: true,
                            },
                            {
                                label: "I don't have a customer ID",
                                value: false,
                            },
                        ], onChange: function (clientIdKnown) { return onChange({ clientIdKnown: clientIdKnown }); } })))),
        value.clientIdKnown === true && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "row mt-3" },
                react_1.default.createElement("div", { className: "col col-6" },
                    react_1.default.createElement(labels_1.Label, { id: "clientId", label: "Customer ID", error: errors === null || errors === void 0 ? void 0 : errors.clientId, required: true },
                        react_1.default.createElement(inputs_1.TextInput, { disabled: readOnly, value: value.clientId || "", onChange: function (clientId) { return setClientId(clientId); }, maxLength: 100 })))),
            value.clientId && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(layout_1.Spinner, { isLoading: clientDetails == null ? true : false, loadingText: " " },
                    react_1.default.createElement("div", { className: "row mt-3" },
                        (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.name) && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "col col-6" },
                                react_1.default.createElement(labels_1.Label, { id: "clientPreview.name", label: "Name" },
                                    react_1.default.createElement(inputs_1.TextInput, { readonly: true, value: (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.name) || "", onChange: function () { } }))))),
                        (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.abn) && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "col col-6" },
                                react_1.default.createElement(labels_1.Label, { id: "clientPreview.abn", label: "ABN" },
                                    react_1.default.createElement(inputs_1.TextInput, { readonly: true, value: (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.abn) || "", onChange: function () { } }))))),
                        (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.email) && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "col col-6" },
                                react_1.default.createElement(labels_1.Label, { id: "clientPreview.email", label: "Email" },
                                    react_1.default.createElement(inputs_1.TextInput, { readonly: true, value: (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.email) || "", onChange: function () { } }))))))))))),
        value.clientIdKnown === false && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "row mt-4" },
                react_1.default.createElement("div", { className: "col col-12" },
                    react_1.default.createElement(labels_1.Label, { id: "clientType", label: "Are you applying as", error: errors === null || errors === void 0 ? void 0 : errors.clientType, required: true },
                        react_1.default.createElement(controls_1.RadioList, { disabled: readOnly, id: "clientType", value: value.clientType, options: [
                                {
                                    label: "Body corporate",
                                    value: ClientTypes.Business,
                                },
                                {
                                    label: "Individual",
                                    value: ClientTypes.Individual,
                                },
                            ], onChange: function (clientType) { return onChange({ clientType: clientType }); } })))),
            value.clientType == ClientTypes.Business && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "row mt-3" },
                    react_1.default.createElement("div", { className: "col col-6" },
                        react_1.default.createElement(labels_1.Label, { id: "clientAbn", label: "ABN", error: errors === null || errors === void 0 ? void 0 : errors.clientABN, required: true },
                            react_1.default.createElement(pickers_1.AbnPicker, { value: value.clientABN || null, onChange: function (v) {
                                    var clientABN = (v === null || v === void 0 ? void 0 : v.abn) || undefined;
                                    if (value.clientABN != clientABN) {
                                        onChange({ clientABN: clientABN });
                                    }
                                    setRegisteredName((v === null || v === void 0 ? void 0 : v.entityName) || "");
                                } }))),
                    react_1.default.createElement("div", { className: "col col-6" },
                        react_1.default.createElement(labels_1.Label, { id: "regiseteredName", label: "Registered Name" },
                            react_1.default.createElement(inputs_1.TextInput, { readonly: true, value: registeredName || "", onChange: function () { } })))))),
            value.clientType == ClientTypes.Individual && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "row mt-3" },
                    react_1.default.createElement("div", { className: "col col-6" },
                        react_1.default.createElement(labels_1.Label, { id: "clientEmail", label: "Email linked to Customer ID", error: errors === null || errors === void 0 ? void 0 : errors.clientEmail, required: true },
                            react_1.default.createElement(inputs_1.TextInput, { value: value.clientEmail || "", onChange: function (clientEmail) {
                                    return onChange({ clientEmail: clientEmail });
                                }, maxLength: 400 })))))),
            (value.clientEmail || value.clientABN) && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "row mt-3" },
                    react_1.default.createElement("div", { className: "col col-6" },
                        react_1.default.createElement(layout_1.Spinner, { isLoading: clientReferences == null, loadingText: " " },
                            react_1.default.createElement(labels_1.Label, { id: "clientId2", label: "Customer ID", error: errors === null || errors === void 0 ? void 0 : errors.clientId, required: true },
                                react_1.default.createElement(controls_1.Select, { options: (clientReferences === null || clientReferences === void 0 ? void 0 : clientReferences.map(function (r) { return ({
                                        label: "".concat(r.clientId, " - ").concat(r.name),
                                        value: r.clientId,
                                    }); }).concat({ label: "New...", value: "new" })) || [], value: value.clientId || null, onChange: function (clientId) {
                                        return setClientId(clientId || undefined);
                                    }, defaultLabel: "Select...", size: "block" }))))))),
            value.clientId == "new" && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "row mt-3" },
                    react_1.default.createElement("div", { className: "col col-12" },
                        react_1.default.createElement(labels_1.Label, { id: "clientName", label: "Trading Name", error: errors === null || errors === void 0 ? void 0 : errors.clientName, required: true },
                            react_1.default.createElement(inputs_1.TextInput, { value: value.clientName || "", onChange: function (clientName) { return onChange({ clientName: clientName }); }, maxLength: 400 })))),
                react_1.default.createElement("div", { className: "row mt-3" },
                    react_1.default.createElement("div", { className: "col col-6" },
                        react_1.default.createElement(labels_1.Label, { id: "clientFirstname", label: "First Name", error: errors === null || errors === void 0 ? void 0 : errors.clientFirstName, required: true },
                            react_1.default.createElement(inputs_1.TextInput, { value: value.clientFirstName || "", onChange: function (clientFirstName) {
                                    return onChange({ clientFirstName: clientFirstName });
                                }, maxLength: 200 }))),
                    react_1.default.createElement("div", { className: "col col-6" },
                        react_1.default.createElement(labels_1.Label, { id: "clientLastName", label: "Last Name", error: errors === null || errors === void 0 ? void 0 : errors.clientLastName, required: true },
                            react_1.default.createElement(inputs_1.TextInput, { value: value.clientLastName || "", onChange: function (clientLastName) {
                                    return onChange({ clientLastName: clientLastName });
                                }, maxLength: 200 })))),
                react_1.default.createElement("div", { className: "row mt-3" },
                    react_1.default.createElement("div", { className: "col col-6" },
                        react_1.default.createElement(labels_1.Label, { id: "clientBusinessPhone", label: "Main phone", error: errors === null || errors === void 0 ? void 0 : errors.clientBusinessPhone, required: true },
                            react_1.default.createElement(inputs_1.TextInput, { value: value.clientBusinessPhone || "", onChange: function (clientBusinessPhone) {
                                    return onChange({ clientBusinessPhone: clientBusinessPhone });
                                }, maxLength: 100 }))),
                    react_1.default.createElement("div", { className: "col col-6" },
                        react_1.default.createElement(labels_1.Label, { id: "clientMobile", label: "Mobile", error: errors === null || errors === void 0 ? void 0 : errors.clientMobile },
                            react_1.default.createElement(inputs_1.TextInput, { value: value.clientMobile || "", onChange: function (clientMobile) {
                                    return onChange({ clientMobile: clientMobile });
                                }, maxLength: 100 })))),
                react_1.default.createElement("div", { className: "row mt-3" },
                    react_1.default.createElement("div", { className: "col col-6" }, value.clientType == ClientTypes.Business && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(labels_1.Label, { id: "clientEmail2", label: "Email", error: errors === null || errors === void 0 ? void 0 : errors.clientEmail, required: true },
                            react_1.default.createElement(inputs_1.TextInput, { value: value.clientEmail || "", onChange: function (clientEmail) {
                                    return onChange({ clientEmail: clientEmail });
                                }, maxLength: 400 }))))),
                    react_1.default.createElement("div", { className: "col col-6" },
                        react_1.default.createElement(labels_1.Label, { id: "clientOtherPhone", label: "Other phone", error: errors === null || errors === void 0 ? void 0 : errors.clientOtherPhone },
                            react_1.default.createElement(inputs_1.TextInput, { value: value.clientOtherPhone || "", onChange: function (clientOtherPhone) {
                                    return onChange({ clientOtherPhone: clientOtherPhone });
                                }, maxLength: 100 })))),
                react_1.default.createElement("div", { className: "row mt-3" },
                    react_1.default.createElement("div", { className: "col col-6" },
                        react_1.default.createElement(labels_1.Label, { id: "clientPostalAddress", label: "Postal Address", error: errors === null || errors === void 0 ? void 0 : errors.clientPostalAddress, required: true },
                            react_1.default.createElement(pickers_1.AddressPicker, { value: value.clientPostalAddress || null, onChange: function (clientPostalAddress) {
                                    return onChange({
                                        clientPostalAddress: clientPostalAddress || undefined,
                                    });
                                } }))),
                    react_1.default.createElement("div", { className: "col col-6" },
                        react_1.default.createElement(labels_1.Label, { id: "clientPhysicalAddress", label: "Business Address", error: errors === null || errors === void 0 ? void 0 : errors.clientBusinessAddress },
                            react_1.default.createElement(pickers_1.AddressPicker, { value: value.clientBusinessAddress || null, onChange: function (clientBusinessAddress) {
                                    return onChange({
                                        clientBusinessAddress: clientBusinessAddress || undefined,
                                    });
                                } })))))))));
};
exports.ClientPicker = ClientPicker;
//# sourceMappingURL=ClientPicker.js.map